import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { DossierService } from './dossier.service';
import { DossierResolver } from './dossier.resolver';
import { DossierListComponent } from './dossier-list.component';
import { DossierEditComponent } from './dossier-edit.component';
import { DossierFilterDialogComponent } from './dossier-filter-dialog.component';
import { DossierSearchDialogComponent } from './dossier-search-dialog.component';
import { DossierTreeComponent } from './tree';
import { DossierTreeItemComponent } from './tree';
import { RecordLinkFormComponent } from './forms/record-link-form.component';
import { DataLinkFormComponent } from './forms/data-link-form.component';
import { LinkGroupFormComponent } from './forms/link-group-form.component';
import { ArchivedDossierListComponent } from './archived-dossier-list.component';
import { ArchivedDossierDetailsComponent } from './archived-dossier-details.component copy';
import { DossierImportComponent } from './dossier-import.component';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    DossierListComponent,
    DossierEditComponent,
    DossierImportComponent,
    DossierFilterDialogComponent,
    DossierSearchDialogComponent,
    DossierTreeComponent,
    DossierTreeItemComponent,
    RecordLinkFormComponent,
    DataLinkFormComponent,
    LinkGroupFormComponent,
    ArchivedDossierListComponent,
    ArchivedDossierDetailsComponent,
  ],
  providers: [
    DossierService,
    DossierResolver
  ],
  bootstrap: [
    DossierFilterDialogComponent,
    DossierSearchDialogComponent,
  ]
})
export class DossierModule { }
